<template>
    <AuthenticatedShell full-bleed-brand>
        <div class="ea-config-layout">
            <div class="ea-config-scroll">
        <div class="wizard ea-config-wizard">
            <section class="section command-list primary config-section">
                <div class="config-panel">
                    <header class="config-header">
                        <h2>Configuração da empresa</h2>
                        <p class="config-lead">
                            Defina logo e contatos da instituição. Os dados ficam no navegador e o
                            texto consolidado fica disponível no store (getter
                            <code>companyContextForAgents</code>) para os agentes de IA.
                        </p>
                    </header>

                    <div class="config-body">
                        <div class="form-group logo-block">
                            <label class="config-label" for="empresa-logo-file">Logotipo</label>
                            <div class="logo-upload-card">
                                <button
                                    type="button"
                                    class="logo-thumb-hit"
                                    aria-label="Escolher imagem do logotipo"
                                    @click="triggerLogoPick"
                                >
                                    <div v-if="form.logoDataUrl" class="logo-preview">
                                        <img :src="form.logoDataUrl" alt="Prévia do logotipo" />
                                    </div>
                                    <div v-else class="logo-placeholder">
                                        <svg
                                            class="logo-placeholder-icon"
                                            width="32"
                                            height="32"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                stroke="currentColor"
                                                stroke-width="1.75"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        <span class="logo-placeholder-title">Adicionar logo</span>
                                        <span class="logo-placeholder-hint">PNG ou JPG · máx. ~1,5 MB</span>
                                    </div>
                                </button>
                                <div class="logo-upload-meta">
                                    <p class="logo-upload-lead">
                                        A imagem entra no perfil da instituição e no texto enviado aos agentes de IA.
                                    </p>
                                    <div class="logo-upload-actions">
                                        <button type="button" class="btn-logo-pick" @click="triggerLogoPick">
                                            Escolher imagem
                                        </button>
                                        <button
                                            v-if="form.logoDataUrl"
                                            type="button"
                                            class="btn-logo-remove"
                                            @click="clearLogo"
                                        >
                                            Remover
                                        </button>
                                    </div>
                                </div>
                                <input
                                    id="empresa-logo-file"
                                    ref="logoFileInput"
                                    type="file"
                                    class="logo-file-hidden"
                                    accept="image/*"
                                    tabindex="-1"
                                    @change="onLogo"
                                />
                            </div>
                        </div>

                        <div class="form-grid">
                            <div class="form-group">
                                <label class="config-label">Nome da instituição</label>
                                <input
                                    v-model="form.companyName"
                                    type="text"
                                    class="form-control config-input"
                                    placeholder="Ex.: Escola Municipal ..."
                                />
                            </div>
                            <div class="form-group">
                                <label class="config-label">E-mail institucional</label>
                                <input
                                    v-model="form.email"
                                    type="email"
                                    class="form-control config-input"
                                    placeholder="contato@escola.edu.br"
                                />
                            </div>
                            <div class="form-group">
                                <label class="config-label">Telefone</label>
                                <input
                                    v-model="form.phone"
                                    type="text"
                                    class="form-control config-input"
                                    placeholder="(00) 00000-0000"
                                />
                            </div>
                            <div class="form-group">
                                <label class="config-label">Site / redes</label>
                                <input
                                    v-model="form.website"
                                    type="text"
                                    class="form-control config-input"
                                    placeholder="https://..."
                                />
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="config-label">Endereço</label>
                            <input
                                v-model="form.address"
                                type="text"
                                class="form-control config-input"
                                placeholder="Rua, número, cidade"
                            />
                        </div>

                        <div class="form-group">
                            <label class="config-label">Outros contatos e observações</label>
                            <textarea
                                v-model="form.extraContacts"
                                class="form-control config-input config-textarea"
                                rows="4"
                                placeholder="WhatsApp, horário de atendimento, departamentos, etc."
                            />
                        </div>

                        <div class="config-actions">
                            <button
                                type="button"
                                class="btn btn-form secondary"
                                @click="resetForm"
                            >
                                Descartar alterações
                            </button>
                            <button
                                type="button"
                                class="btn btn-form primary"
                                @click="save"
                            >
                                Salvar empresa
                            </button>
                        </div>

                        <div v-if="preview" class="context-preview">
                            <span class="preview-title">Prévia do contexto para agentes</span>
                            <pre>{{ preview }}</pre>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            </div>
        </div>
    </AuthenticatedShell>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';
import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';

export default {
    name: 'EscoConfiguracaoEmpresa',
    components: { AuthenticatedShell },
    data() {
        return {
            form: {
                logoDataUrl: '',
                companyName: '',
                email: '',
                phone: '',
                website: '',
                address: '',
                extraContacts: ''
            }
        };
    },
    computed: {
        ...mapState(['companyProfile']),
        ...mapGetters(['companyContextForAgents']),
        preview() {
            return this.companyContextForAgents || '(preencha os campos acima)';
        }
    },
    mounted() {
        this.form = { ...this.form, ...this.companyProfile };
    },
    methods: {
        ...mapActions(['storeCompanyProfile']),
        notify(msg, type = 'info') {
            toast(msg, { autoClose: 3000, type });
        },
        triggerLogoPick() {
            this.$refs.logoFileInput?.click();
        },
        clearLogo() {
            this.form.logoDataUrl = '';
            const el = this.$refs.logoFileInput;
            if (el) el.value = '';
        },
        onLogo(ev) {
            const file = ev.target.files && ev.target.files[0];
            if (!file) return;
            if (file.size > 1.5 * 1024 * 1024) {
                this.notify('Imagem muito grande. Use até ~1,5 MB.', 'error');
                ev.target.value = '';
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.form.logoDataUrl = reader.result;
            };
            reader.readAsDataURL(file);
            ev.target.value = '';
        },
        save() {
            this.storeCompanyProfile({ companyProfile: { ...this.form } });
            this.notify('Dados da empresa salvos.', 'success');
        },
        resetForm() {
            this.form = { ...this.form, ...this.companyProfile };
            this.notify('Formulário restaurado ao último salvo.', 'info');
        }
    }
};
</script>

<style lang="scss" scoped>
$ea-accent: #8b9185;
$ea-accent-soft: rgba(139, 145, 133, 0.18);
$ea-card: #15161a;
$ea-elevated: #1c1d22;
$ea-muted: #8b9099;

.ea-config-layout {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ea-config-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 0.5rem clamp(0.75rem, 2.5vw, 1.5rem) 1.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.ea-config-scroll::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.ea-config-wizard {
    width: 100%;
    max-width: none;
}

.config-section {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;
}

.config-panel {
    background: $ea-card;
    border-radius: 12px;
    padding: clamp(1.25rem, 3vw, 2rem);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: none;
}

.config-header h2 {
    margin: 0 0 0.35rem;
    font-size: clamp(1.25rem, 2.5vw, 1.6rem);
    color: #fff;
    font-weight: 700;
}

.config-lead {
    margin: 0 0 1.25rem;
    color: $ea-muted;
    font-size: 14px;
    line-height: 1.55;
}

.config-lead code {
    font-size: 12px;
    color: #b8bcb4;
    background: rgba(0, 0, 0, 0.35);
    padding: 0.15rem 0.4rem;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.config-body {
    color: #fff;
}

.config-label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 13px;
    color: #c8cdd8;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
}

.config-input {
    background: $ea-elevated !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
    border-radius: 10px !important;
}
.config-input:focus {
    outline: none;
    border-color: rgba(139, 145, 133, 0.55) !important;
    box-shadow: 0 0 0 2px $ea-accent-soft;
}

.config-textarea {
    resize: vertical;
    min-height: 96px;
}

.logo-upload-card {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 1.15rem 1.35rem;
    padding: 1.1rem 1.2rem;
    background: $ea-elevated;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    position: relative;
}

.logo-file-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
    opacity: 0;
    pointer-events: none;
}

.logo-thumb-hit {
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 14px;
    flex-shrink: 0;
    text-align: left;
    font: inherit;
    color: inherit;
}

.logo-thumb-hit:focus-visible {
    outline: 2px solid rgba(139, 145, 133, 0.55);
    outline-offset: 3px;
}

.logo-preview {
    width: 104px;
    height: 104px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.logo-thumb-hit:hover .logo-preview {
    border-color: rgba(139, 145, 133, 0.45);
    box-shadow: 0 0 0 1px rgba(139, 145, 133, 0.2);
}

.logo-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.logo-placeholder {
    width: 104px;
    height: 104px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    padding: 0.5rem;
    box-sizing: border-box;
    border: 1px dashed rgba(255, 255, 255, 0.14);
    transition: border-color 0.15s ease, background 0.15s ease;
}

.logo-thumb-hit:hover .logo-placeholder {
    border-color: rgba(139, 145, 133, 0.4);
    background: rgba(139, 145, 133, 0.06);
}

.logo-placeholder-icon {
    color: #6b7280;
}

.logo-placeholder-title {
    font-size: 11px;
    font-weight: 600;
    color: #c8cdd8;
    letter-spacing: 0.02em;
}

.logo-placeholder-hint {
    font-size: 10px;
    color: $ea-muted;
    text-align: center;
    line-height: 1.25;
    max-width: 92px;
}

.logo-upload-meta {
    flex: 1 1 200px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.85rem;
}

.logo-upload-lead {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #9aa3b2;
}

.logo-upload-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
}

.btn-logo-pick {
    padding: 0.45rem 1rem;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid rgba(139, 145, 133, 0.45);
    background: $ea-accent-soft;
    color: #f2f3f5;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.btn-logo-pick:hover {
    background: rgba(139, 145, 133, 0.28);
    border-color: rgba(139, 145, 133, 0.6);
}

.btn-logo-remove {
    padding: 0.45rem 0.85rem;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: transparent;
    color: #9aa3b2;
    cursor: pointer;
}

.btn-logo-remove:hover {
    color: #e8eaef;
    border-color: rgba(255, 255, 255, 0.18);
}

.config-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin: 1.5rem 0 0;
}

.btn-form {
    padding: 0.6rem 1.35rem;
    border-radius: 999px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.btn-form:active {
    transform: scale(0.98);
}

.btn-form.primary {
    background: #3d4046;
    color: #f0f1f3;
    box-shadow: none;
}
.btn-form.primary:hover {
    background: #484c54;
}

.btn-form.secondary {
    background: transparent;
    color: #c4c8cf;
    border: 1px solid rgba(255, 255, 255, 0.12);
}
.btn-form.secondary:hover {
    border-color: rgba(139, 145, 133, 0.4);
    color: #e8eaef;
}

.context-preview {
    margin-top: 1.5rem;
    padding: 1rem 1.1rem;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    border: 1px dashed rgba(255, 255, 255, 0.1);
}

.preview-title {
    display: block;
    font-size: 12px;
    color: $ea-muted;
    margin-bottom: 0.5rem;
}

.context-preview pre {
    margin: 0;
    white-space: pre-wrap;
    font-size: 12px;
    color: #c8cdd8;
    line-height: 1.45;
}
</style>
